module.exports = __webpack_public_path__ + "media/images/features/draft/icon-flow-01-a9363b944515408d710961e758a24cba.svg";